import { formatTimecodeHMMSS } from '../../FormatTime';

/**
 * Что экран «Распознавание» передаёт вкладке «Протокол».
 *
 * 🔴 Три последних поля до 01.09.2026 уходили пустыми (`null, {}, []`), и это
 * ломало две вещи молча:
 *  - без `taskId` протокол заводил в Истории ВТОРУЮ запись вместо того, чтобы
 *    дописаться в существующую: привязка идёт по нему (`App.js:272`);
 *  - без него же выключено «запомнить голос» в Протоколе
 *    (`voiceIdReady={!!state.sourceTaskId}`), а без `speakerIdByLabel` его не к
 *    чему привязать: векторы в bit-history лежат под меткой диаризации
 *    `SPEAKER_N`, а человек видит имя.
 *
 * Функция чистая: экран решает, когда передавать, а что именно — проверяется
 * тестом без React.
 */

/** Реплика строкой: «Имя [0:00:25]: текст». Столько же, сколько уходит в Историю.
 *
 * 🔴 Таймкод стоит ДО двоеточия, а не после. Разбор расшифровки ждёт его именно
 * там (`transcriptParse.LINE_RE`), и при обратном порядке таймкод оставался
 * внутри текста реплики: соседние реплики одного человека склеивались в блок, и
 * времена оказывались посреди абзаца — «…расскажут о себе. [0:00:58] Коллеги, у
 * вас микрофоны есть?». Найдено владельцем 05.09.2026.
 */
function line(fragment, withTimecode) {
  const timecode = withTimecode && typeof fragment.start === 'number'
    ? `[${formatTimecodeHMMSS(fragment.start)}]` : null;
  const head = [fragment.speaker || null, timecode].filter(Boolean).join(' ');
  return head ? `${head}: ${fragment.text}` : fragment.text;
}

export function protocolHandoff(result, { fileName } = {}) {
  const fragments = (result && result.fragments) || [];
  const status = (result && result.status) || {};

  // Метка на экране → метка диаризации. Ключ — ровно та строка, что стоит в
  // тексте перед двоеточием: по ней Протокол ищет участника для переименования.
  const speakerIdByLabel = {};
  fragments.forEach((f) => {
    if (f.speaker && f.speakerId) speakerIdByLabel[f.speaker] = f.speakerId;
  });

  const recognizedSpeakers = Object.entries(status.speaker_names || {})
    .map(([speakerId, name]) => ({ speakerId, name, label: name }));

  return {
    text: fragments.map((f) => line(f, false)).join('\n'),
    // Версия с таймкодами — под переключатель «показать таймкоды» в Протоколе
    // (`TranscriptionTab`: rawText показывается вместо text, когда он отличается).
    rawText: fragments.map((f) => line(f, true)).join('\n'),
    fileName: fileName || '',
    taskId: (result && result.taskId) || status.task_id || null,
    speakerIdByLabel,
    recognizedSpeakers,
  };
}
